import {Button, Modal} from '@yandex-delivery/blocks'
import React from 'react'

import {i18n} from 'src/shared/config'

import type {Props} from './types'

export const ConfirmModal = React.memo<Props>(function ConfirmModal(props) {
  const {open, isPending = false, children, locale, ModalProps, onSubmit, onCancel} = props

  return (
    <Modal {...ModalProps} onClose={onCancel} opened={open}>
      <div data-e2e="modal-optimize-route">
        <Modal.Header title={locale.title} />
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <Modal.Footer.Controls>
            <Button data-e2e="button-cancel" disabled={isPending} onPress={onCancel}>
              {locale.cancel || i18n('modal.confirm.cancel', 'Отменить')}
            </Button>
            <Button data-e2e="button-save" disabled={isPending} onPress={onSubmit} variant="action">
              {locale.submit || i18n('modal.confirm.ok', 'ОК')}
            </Button>
          </Modal.Footer.Controls>
        </Modal.Footer>
      </div>
    </Modal>
  )
})
